import { render, staticRenderFns } from "./ClassUpdateDialog.vue?vue&type=template&id=15656c22"
import script from "./ClassUpdateDialog.vue?vue&type=script&lang=js"
export * from "./ClassUpdateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports